@import "@/scss/use-bootstrap-mixins.scss";

.form {
  .field {
    margin-bottom: 20px;

    span.header_text {
      color: $primaryOnBackground !important;
      margin: 0 !important;
      font-size: calc(1.3rem + 0.6vw);
      font-weight: 600 !important;
    }

    .row {
      display: flex;
      flex-direction: column;
      gap: 12px;

      @include media-breakpoint-up(lg) {
        flex-direction: row;
      }

      .column {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 1;

        @include media-breakpoint-up(lg) {
          gap: 12px;
        }

        .subtitle {
          color: $primaryOnBackground !important;
          font-size: 16px;
          display: block;
        }

        input,
        .datepicker {
          width: 100%;
          border: 1px solid #d0d0d0;
          border-radius: 4px !important;
          padding: 13px 15px;
          font-size: 14px;
          background-color: #fff;
        }

        .upload {
          position: relative;
          background-color: #fff;
          padding: 13px 15px;
          border-radius: 4px !important;
          font-size: 14px;
          border: 1px solid #d0d0d0;
          text-align: center;

          span {
            display: block;
            font-size: 12px;
            font-style: italic;
            max-width: 300px;
            margin: 0 auto;
          }

          input[type="file"] {
            display: block;
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            opacity: 0;
            cursor: pointer;
          }
        }

        .fileName {
          font-size: 14px !important;
          color: #d04d52 !important;
          background-color: #faeded;
          border: 1px solid #d04d52;
          padding: 12px 12px;
          border-radius: 4px;
          display: block;
          font-weight: 500 !important;
          text-align: center !important;
        }
      }
    }
  }
}
